export default {
  adjustment_list_invalid: {
    description: "Employee code does not exist! Please check and import again!",
    nativeDescription:
      "Mã nhân viên không tồn tại! Vui lòng kiểm tra và import lại!",
  },
  allowance_in_use_compensation: {
    description:
      "The allowance has been used on compensation package! You can not delete the allowance!",
    nativeDescription:
      "Khoản phụ cấp đã được sử dụng trong chính sách lương thưởng! Bạn không thể xóa khoản phụ cấp này!",
  },
  allowance_in_use_compensation_employee: {
    description:
      "The allowance is being used for employee profile! You can not delete the allowance!",
    nativeDescription:
      "Khoản phụ cấp đã được sử dụng trong hồ sơ nhân viên! Bạn không thể xóa khoản phụ cấp này!",
  },
  payroll_flow_has_been_used: {
    description: "The flow has been used! You can not edit or delete!",
    nativeDescription:
      "Luồng duyệt đã được sử dụng! Bạn không thể sửa hoặc xóa!",
  },
  employee_codes_invalid: {
    description: "The employee code is not valid. Please check again!",
    nativeDescription: "Mã nhân viên không hợp lệ. Vui lòng kiểm tra lại!",
  },
  employee_bank_account_not_found: {
    description: "Bank account number not found. Please check again!",
    nativeDescription: "Số tài khoản NH không tồn tại. Vui lòng kiểm tra lại!",
  },
  bank_account_must_have_a_primary: {
    description: "Must have a main bank account to receive salary!",
    nativeDescription: "Phải có một tài khoản NH chính để nhận lương!",
  },
  error_to_send_mail: {
    description: "Failed to send the payslip. Please try again.",
    nativeDescription:
      "Gửi mail phiếu lương không thành công. Vui lòng thử lại!",
  },
  salary_advance_lock: {
    description: "The Salary Advance has been locked. You can not delete!",
    nativeDescription: "Bảng tạm ứng đã được khóa. Bạn không thể sửa hay xóa!",
  },
  import_error: {
    description: "Import error! Please check and import again!",
    nativeDescription: "Lỗi import! Vui lòng kiểm tra và import lại!",
  },
  effective_from_less_than_allowance_setting: {
    description:
      "The start date set up is earlier than the start date of the allowance in the master data.",
    nativeDescription:
      "Ngày bắt đầu được thiết lập nhỏ hơn ngày bắt đầu của phụ cấp trong dữ liệu chính.",
  },
  effective_from_more_than_allowance_setting: {
    description:
      "The start date set up is later than the allowance's start date in the master data.",
    nativeDescription:
      "Ngày bắt đầu được thiết lập lớn hơn ngày bắt đầu của phụ cấp trong dữ liệu chính.",
  },
  effective_from_to_not_set_up: {
    description: "Earnings or allowances have been set up for employees.",
    nativeDescription: "Lương hoặc Phụ cấp đã có trong hồ sơ nhân viên.",
  },
  effective_to_not_set_date: {
    description: "Earnings or allowances have been set up for employees. ",
    nativeDescription: "Lương hoặc Phụ cấp đã có trong hồ sơ nhân viên.",
  },
  not_allow_two_effective_to_not_set_up: {
    description:
      "Earnings or allowances that existed during this period. Please check again.",
    nativeDescription:
      "Lương hoặc Phụ cấp đã tồn tại trong khoảng thời gian này. Vui lòng kiểm tra lại.",
  },
  effective_from_to_overlap: {
    description:
      "Earnings or allowances that existed during this period. Please check again.",
    nativeDescription:
      "Lương hoặc Phụ cấp đã tồn tại trong khoảng thời gian này. Vui lòng kiểm tra lại.",
  },
  payroll_not_exist_not_approved: {
    description: "There is no approved payroll for the selected period.",
    nativeDescription: "Chưa có bảng lương được duyệt trong kì được chọn.",
  },
  employees_not_found: {
    description:
      "The employee code does not exist or the employee is not assigned to this payroll template.",
    nativeDescription:
      "Mã code của nhân viên không tồn tại hoặc nhân viên chưa được gắn vào bảng lương này.",
  },
  salary_advance_include_invalid_employee: {
    description:
      "The employee code does not exist or the employee is not assigned to this payroll template.",
    nativeDescription:
      "Mã code của nhân viên không tồn tại hoặc nhân viên chưa được gắn vào bảng lương này.",
  },
  salary_payment_include_invalid_employee: {
    description:
      "The employee code does not exist or the employee is not assigned to this payroll template.",
    nativeDescription:
      "Mã code của nhân viên không tồn tại hoặc nhân viên chưa được gắn vào bảng lương này.",
  },
  template_not_found: {
    description: "The payroll template does not exist.",
    nativeDescription: "Bảng lương mẫu không tồn tại.",
  },
  template_period_invalid: {
    description: "The payroll period is invalid.",
    nativeDescription: "Giai đoạn của bảng lương không hợp lệ.",
  },
  payment_not_found: {
    description: "The Salary Advance or Salary payment not found. ",
    nativeDescription: "Không tìm thấy bảng tạm ứng hoặc bảng chi trả.",
  },
  payment_lock: {
    description:
      "The Salary Advance or Salary payment has been locked. You can not edit or delete!",
    nativeDescription:
      "Bảng tạm ứng hoặc Bảng chi trả đã được khóa. Bạn không thể sửa hay xóa!",
  },
  time_attendance_locked: {
    description: "Time attendance data has been locked by payroll cycle.",
    nativeDescription: "Dữ liệu chấm công đã được khoá theo chu kỳ lương.",
  },
  item_approve_pending_status: {
    description:
      "The payroll is either pending approval or has already been approved.",
    nativeDescription: "Bảng lương đang ở trạng thái chờ duyệt hoặc đã duyệt.",
  },
  attendance_ot_leave_not_locked: {
    description:
      "Please lock the data before running payroll with adjustments.",
    nativeDescription:
      "Vui lòng khóa dữ liệu trước khi chạy bảng lương có điều chỉnh.",
  },
  salary_period_locked: {
    description: "The salary period has been approved. Please check the data.",
    nativeDescription: "Kì lương đã được duyệt. Vui lòng kiểm tra lại dữ liệu.",
  },
  template_period_not_found: {
    description: "Salary template not found. Please check the data.",
    nativeDescription:
      "Không tìm thấy bảng lương mẫu. Vui lòng kiểm tra lại dữ liệu.",
  },
  attendances_do_not_existed: {
    description:
      "Employees do not have attendance data or have not added data to adjustments. Please check again.",
    nativeDescription:
      "Dữ liệu công không tồn tại. Vui lòng kiểm tra lại dữ liệu",
  },
  employees_do_not_have_attendances: {
    description:
      "Employees do not have attendance data or have not added data to adjustments. Please check again.",
    nativeDescription:
      "Nhân viên chưa có dữ liệu công hoặc chưa thêm dữ liệu vào điều chỉnh. Vui lòng kiểm tra lại.",
  },
  duplicate_deduction: {
    description: "Duplicate deduction. Please check the data.",
    nativeDescription:
      "Khoản giảm trừ trùng lặp. Vui lòng kiểm tra lại dữ liệu.",
  },
  from_or_to_in_others: {
    description: "There is another cycle in this period.",
    nativeDescription: "Đã tồn tại chu kỳ khác trong khoảng thời gian này.",
  },
  employees: {
    description: "Employees should not be empty.",
    nativeDescription: "Nhân viên không được để trống.",
  },
  ids_not_found: {
    description: "The list does not exist.",
    nativeDescription: "Danh sách không tồn tại.",
  },
  pit_run_payroll_warning: {
    description:
      "The transaction has been applied for payroll. You must re-run payroll calculations after deleting the transaction.",
    nativeDescription:
      "Giao dịch đã được áp dụng trên bảng lương. Bạn cần chạy lại tính lương sau khi xoá.",
  },
  productivity_template_field_not_found: {
    description: "Productivity template field not found.",
    nativeDescription: "Không tìm thấy trường của mẫu năng suất.",
  },
  productivity_template_not_found: {
    description: "Productivity template not found.",
    nativeDescription: "Không tìm thấy mẫu năng suất.",
  },
  template_field_not_found: {
    description: "Template field not found.",
    nativeDescription: "Không tìm thấy trường của mẫu.",
  },
  deduction_not_found: {
    description: "Deduction not found.",
    nativeDescription: "Không tìm thấy khoản khấu trừ.",
  },
  payroll_cycles_invalid: {
    description: "Payroll cycles are not valid.",
    nativeDescription: "Kỳ lương không hợp lệ.",
  },
  allowance_not_found: {
    description: "Allowance not found.",
    nativeDescription: "Không tìm thấy phụ cấp.",
  },
  application_invalid: {
    description: "Invalid application.",
    nativeDescription: "Ứng dụng không hợp lệ.",
  },
  approval_request_not_found: {
    description: "You are not the approver of this request.",
    nativeDescription: "Bạn không phải người phê duyệt của yêu cầu này.",
  },
  approval_workflow_not_found: {
    description: "Approval workflow not found.",
    nativeDescription: "Không tìm thấy quy trình phê duyệt.",
  },
  attendance_list_empty: {
    description: "Attendance list is empty.",
    nativeDescription: "Danh sách chấm công đang trống.",
  },
  benefit_in_kind_not_found: {
    description: "Benefit In Kind not found.",
    nativeDescription: "Không tìm thấy phúc lợi không bằng tiền.",
  },
  benefitInKind_codes_invalid: {
    description: "Benefit-in-kind codes are invalid.",
    nativeDescription: "Mã phúc lợi không hợp lệ.",
  },
  can_not_update_item: {
    description: "Cannot update the item.",
    nativeDescription: "Không thể cập nhật mục này.",
  },
  can_not_update_item_inactive: {
    description: "Cannot update an inactive item.",
    nativeDescription: "Không thể cập nhật mục đang ngưng hoạt động.",
  },
  company_working_day_not_found: {
    description: "Company working day config not found.",
    nativeDescription: "Không tìm thấy cấu hình ngày công chuẩn.",
  },
  compensation_not_found: {
    description: "Compensation not found.",
    nativeDescription: "Không tìm thấy chính sách lương.",
  },
  cycle_invalid: {
    description: "Cycle is invalid.",
    nativeDescription: "Chu kỳ không hợp lệ.",
  },
  deduction_in_use_compensation: {
    description: "Deduction is being used for compensation.",
    nativeDescription: "Khoản khấu trừ đang được dùng trong chính sách lương.",
  },
  duplicate_effective_from: {
    description: "Duplicate 'Effective from' is not allowed.",
    nativeDescription: "Không cho phép trùng ngày hiệu lực.",
  },
  earning_codes_invalid: {
    description: "Earning codes are invalid.",
    nativeDescription: "Mã thu nhập không hợp lệ.",
  },
  effective_from_same_after_to: {
    description: "'Effective from' must be before 'Effective to'.",
    nativeDescription: "Ngày hiệu lực từ phải trước ngày hiệu lực đến.",
  },
  effective_from_to_invalid: {
    description: "'Effective from' or 'Effective to' is invalid.",
    nativeDescription: "Ngày hiệu lực từ/đến không hợp lệ.",
  },
  email_template_not_found: {
    description: "Email template not found.",
    nativeDescription: "Không tìm thấy mẫu email.",
  },
  employee_allowance_not_found: {
    description: "Employee's allowance not found.",
    nativeDescription: "Không tìm thấy phụ cấp của nhân viên.",
  },
  employee_benefit_in_kind_not_found: {
    description: "Employee's benefit in kind not found.",
    nativeDescription: "Không tìm thấy phúc lợi của nhân viên.",
  },
  employee_code_invalid: {
    description: "Employee code is invalid.",
    nativeDescription: "Mã nhân viên không hợp lệ.",
  },
  employee_deduction_not_found: {
    description: "Employee's deduction not found.",
    nativeDescription: "Không tìm thấy khoản khấu trừ của nhân viên.",
  },
  employee_earning_not_found: {
    description: "Employee's earning not found.",
    nativeDescription: "Không tìm thấy khoản thu nhập của nhân viên.",
  },
  employee_leave_not_found: {
    description: "Employee Leave not found.",
    nativeDescription: "Không tìm thấy ngày nghỉ của nhân viên.",
  },
  employee_list_invalid: {
    description: "Employee list not found.",
    nativeDescription: "Không tìm thấy danh sách nhân viên.",
  },
  employees_not_found_in_tum: {
    description: "Employee codes not found.",
    nativeDescription: "Không tìm thấy mã nhân viên trong hệ thống.",
  },
  exist_item: {
    description: "Template field code already exists.",
    nativeDescription: "Mã trường của mẫu đã tồn tại.",
  },
  formula_invalid: {
    description: "Formula is invalid.",
    nativeDescription: "Công thức không hợp lệ.",
  },
  from_more_than_to: {
    description: "'From' must not be greater than 'To'.",
    nativeDescription: "Giá trị Từ không được lớn hơn Đến.",
  },
  fromDate_is_after_toDate: {
    description: "From date must be before To date.",
    nativeDescription: "Ngày bắt đầu phải trước ngày kết thúc.",
  },
  group_machine_not_found: {
    description: "Group Machine not found.",
    nativeDescription: "Không tìm thấy nhóm máy.",
  },
  holiday_not_found: {
    description: "Holiday not found.",
    nativeDescription: "Không tìm thấy ngày lễ.",
  },
  id_invalid: {
    description: "Id/code is invalid.",
    nativeDescription: "Id/mã không hợp lệ.",
  },
  invalid_code: {
    description: "Allowance Code is invalid.",
    nativeDescription: "Mã phụ cấp không hợp lệ.",
  },
  invalid_partner: {
    description: "Invalid partner setting.",
    nativeDescription: "Cấu hình đối tác không hợp lệ.",
  },
  item_not_exist: {
    description: "Item does not exist.",
    nativeDescription: "Mục không tồn tại.",
  },
  leave_locked: {
    description: "Leave data has been locked.",
    nativeDescription: "Dữ liệu nghỉ phép đã bị khóa.",
  },
  leave_policy_not_found: {
    description: "Leave Policy not found.",
    nativeDescription: "Không tìm thấy chính sách nghỉ phép.",
  },
  leave_type_not_found: {
    description: "Leave Type not found.",
    nativeDescription: "Không tìm thấy loại ngày nghỉ phép.",
  },
  lock_data_not_found: {
    description: "Lock data not found.",
    nativeDescription: "Không tìm thấy dữ liệu khóa.",
  },
  machine_not_found: {
    description: "Machine not found.",
    nativeDescription: "Không tìm thấy máy.",
  },
  mes_response_is_empty: {
    description: "MES response is empty.",
    nativeDescription: "Phản hồi từ MES rỗng.",
  },
  mes_standard_quantity_not_found: {
    description: "MES Standard Quantity not found (Sync it first).",
    nativeDescription:
      "Không tìm thấy sản lượng chuẩn MES (vui lòng đồng bộ trước).",
  },
  must_move_template_field: {
    description:
      "Please move the template fields to another group before deleting.",
    nativeDescription:
      "Vui lòng chuyển các trường sang nhóm khác trước khi xóa.",
  },
  not_allow_delete_system_group_data: {
    description: "Cannot delete system group data.",
    nativeDescription: "Không thể xóa nhóm dữ liệu hệ thống.",
  },
  not_allow_to_delete_system_field: {
    description: "Cannot delete system fields.",
    nativeDescription: "Không thể xóa trường hệ thống.",
  },
  not_found_employee_productivity_template: {
    description: "This productivity template has no employees.",
    nativeDescription: "Mẫu năng suất này chưa có nhân viên nào.",
  },
  objectId_invalid: {
    description: "Your request is invalid. Please check again.",
    nativeDescription: "Yêu cầu không hợp lệ. Vui lòng kiểm tra lại.",
  },
  organization_invalid: {
    description: "Invalid organization.",
    nativeDescription: "Tổ chức không hợp lệ.",
  },
  ot_not_found: {
    description: "OT not found.",
    nativeDescription: "Không tìm thấy dữ liệu tăng ca.",
  },
  ot_rate_not_allow_update: {
    description: "Overtime rate cannot be updated.",
    nativeDescription: "Không thể cập nhật tỉ lệ tăng ca.",
  },
  payroll_cycle_not_found: {
    description: "Payroll cycle not found.",
    nativeDescription: "Không tìm thấy kỳ lương.",
  },
  payroll_not_found: {
    description: "Payroll not found.",
    nativeDescription: "Không tìm thấy bảng lương.",
  },
  pit_not_valid: {
    description: "Please select only one tax payer: Company or Employee.",
    nativeDescription:
      "Chỉ được chọn một bên chịu thuế: Công ty hoặc Người lao động.",
  },
  pit_rate_not_found: {
    description: "PIT rate not found.",
    nativeDescription: "Không tìm thấy biểu thuế TNCN.",
  },
  product_not_found: {
    description: "Product not found.",
    nativeDescription: "Không tìm thấy sản phẩm.",
  },
  productivity_template_payroll_cycle_not_found: {
    description: "Productivity Template's payroll cycle not found.",
    nativeDescription: "Không tìm thấy kỳ lương của mẫu năng suất.",
  },
  reason_stop_machine_not_found: {
    description: "Reason Stop Machine not found.",
    nativeDescription: "Không tìm thấy lý do dừng máy.",
  },
  region_wage_not_found: {
    description: "Region Wage not found.",
    nativeDescription: "Không tìm thấy lương tối thiểu vùng.",
  },
  request_not_approved: {
    description: "The summary productivity salary request is not yet approved.",
    nativeDescription: "Yêu cầu lương năng suất tổng hợp chưa được duyệt.",
  },
  request_not_found: {
    description: "Request not found or not pending.",
    nativeDescription:
      "Không tìm thấy yêu cầu hoặc yêu cầu không ở trạng thái chờ duyệt.",
  },
  salary_advance_not_approve_yet: {
    description: "This salary advance has not been approved.",
    nativeDescription: "Bảng tạm ứng lương chưa được duyệt.",
  },
  salary_advance_not_found: {
    description: "Salary Advance not found.",
    nativeDescription: "Không tìm thấy bảng tạm ứng lương.",
  },
  salary_payment_not_approve_yet: {
    description: "This salary payment has not been approved.",
    nativeDescription: "Bảng chi trả lương chưa được duyệt.",
  },
  salary_payment_not_found: {
    description: "Salary Payment not found.",
    nativeDescription: "Không tìm thấy bảng chi trả lương.",
  },
  standard_quantity_not_found: {
    description: "Standard Quantity not found.",
    nativeDescription: "Không tìm thấy sản lượng chuẩn.",
  },
  status_invalid: {
    description: "Invalid status.",
    nativeDescription: "Trạng thái không hợp lệ.",
  },
  system_field_codes_required: {
    description: "System field codes are required.",
    nativeDescription: "Vui lòng nhập mã trường hệ thống.",
  },
  system_group_field_not_found: {
    description: "System Group Field not found.",
    nativeDescription: "Không tìm thấy nhóm trường hệ thống.",
  },
  template_group_field_not_found: {
    description: "Template Group Field not found.",
    nativeDescription: "Không tìm thấy nhóm trường của mẫu.",
  },
  time_work_from_to_must_not_be_null: {
    description: "Working time (from/to) is required when status is active.",
    nativeDescription:
      "Cần nhập thời gian làm việc (từ/đến) khi trạng thái là hoạt động.",
  },
  work_level_already_exist: {
    description: "Work level already exists.",
    nativeDescription: "Cấp bậc đã tồn tại.",
  },
  work_level_compensation_not_found: {
    description: "Work Level's compensation not found.",
    nativeDescription: "Không tìm thấy cấp bậc trong chính sách lương.",
  },
  work_level_not_found: {
    description: "Work Level not found.",
    nativeDescription: "Không tìm thấy cấp bậc.",
  },
  work_shift_not_found: {
    description: "Work Shift not found.",
    nativeDescription: "Không tìm thấy ca làm việc.",
  },
  workshift_codes_invalid: {
    description: "Work shift codes are invalid.",
    nativeDescription: "Mã ca làm việc không hợp lệ.",
  },
  year_invalid: {
    description: "Invalid year.",
    nativeDescription: "Năm không hợp lệ.",
  },
  ot_locked: {
    description: "OT data has been locked.",
    nativeDescription: "Dữ liệu OT đã được khoá.",
  },
  update_template_field_list_fail: {
    description: "Failed to update the template field list.",
    nativeDescription: "Lỗi cập nhật danh sách tham số.",
  },
  default: {
    description: "Something went wrong! Please try again!",
    nativeDescription: "Đã có lỗi xảy ra! Vui lòng thử lại!",
  },
} as const;
